import React, { useEffect, useState } from "react";
import api from "../../lib/api";
import { CalendarBlank, Trophy, SoccerBall, MapPin } from "@phosphor-icons/react";

export default function ParentSchedule() {
  const [data, setData] = useState({ matches: [], practices: [] });
  useEffect(() => { api.get("/parent/schedule").then((r) => setData(r.data)); }, []);

  const events = [
    ...data.matches.map((m) => ({ type: "match", date: m.match_date, time: m.match_time, title: `vs ${m.opponent}`, sub: m.location, item: m })),
    ...data.practices.map((p) => ({ type: "practice", date: p.practice_date, time: "", title: p.title, sub: `${p.duration_minutes} min`, item: p })),
  ].sort((a, b) => a.date.localeCompare(b.date));

  return (
    <div className="space-y-6">
      <div>
        <div className="overline">Upcoming</div>
        <h1 className="font-display font-black text-4xl uppercase tracking-tight mt-1">Schedule</h1>
      </div>
      {events.length === 0 ? (
        <div className="bg-[#121212] border border-neutral-800 rounded-lg p-10 text-center overline">Nothing coming up</div>
      ) : (
        <div className="space-y-3">
          {events.map((e, i) => {
            const Icon = e.type === "match" ? Trophy : SoccerBall;
            const color = e.type === "match" ? "#D90429" : "#06D6A0";
            return (
              <div key={i} className="bg-[#121212] border border-neutral-800 rounded-lg p-4 flex items-center gap-4">
                <div className="w-14 h-14 rounded-md flex flex-col items-center justify-center text-center" style={{ background: color, color: e.type === "match" ? "#fff" : "#050505" }}>
                  <Icon size={22} weight="fill" />
                </div>
                <div className="flex-1">
                  <div className="font-display font-bold text-lg uppercase tracking-tight">{e.title}</div>
                  <div className="text-xs text-neutral-400 flex flex-wrap gap-3 mt-1">
                    <span className="flex items-center gap-1"><CalendarBlank size={12} weight="bold" /> {e.date} {e.time}</span>
                    {e.sub && <span className="flex items-center gap-1"><MapPin size={12} weight="bold" /> {e.sub}</span>}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
